angular.module('bribac.components.boostImage', [
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.services.api',
  'bribac.components.whenLoaded',
  'bribac.components.imageMultiSelect'
])

  .component('boostImage', {
    templateUrl: 'boost-image-component.html',
    controller: 'BoostImageComponentCtrl',
      bindings: {
          boostImages: '='
      }
  })

  .controller('BoostImageComponentCtrl', function(
    api,
    KINDS
  ) {
      var $ctrl = this

      $ctrl.$onInit = function () {
          $ctrl.boostImagePromise = api.getBoostImages(KINDS.BOOST_IMAGE).then(function (request) {
              $ctrl.imageList = request.data.list
              $ctrl.boostImages = !!$ctrl.boostImages ? $ctrl.boostImages : [];
              // check only items that are checked
              $ctrl.imageList.forEach(function (boostImage) {
                  var result = $ctrl.boostImages.find(function (obj) {
                      return obj.id === boostImage.id
                  })
                  boostImage.isChecked = !!result
              })
          });
      }

      $ctrl.onImageSelect = function(newRuleSet) {
          newRuleSet.forEach(function (image) {
              $ctrl.boostImages = $ctrl.boostImages.filter(function (img) { return img.id !== image.id })
              if (image.isChecked) {
                  $ctrl.boostImages.push({id: image.id, url: image.url});
              }
          })
      }
  })
